export default new class Device {


	constructor() {
		this.IS_TOUCH = null;
	}


	init($html = $('html')) {
		this._initDOM($html);
		this._initEl();
	}


	_initDOM($html) {
		this.$html = $html;
	}


	_initEl() {
		this._setValues();
		this._setBodyClass();
	}


	_setValues() {
		// this.IS_TOUCH = window.matchMedia( '(pointer: coarse)' ).matches;
		this.IS_TOUCH = ScrollTrigger.isTouch;
	}


	/*_getIsTouch() {
		// return ( ( 'ontouchstart' in window) ||
		// 	   ( navigator.maxTouchPoints > 0 ) ||
		// 	   ( navigator.msMaxTouchPoints > 0 ) );
		
		if ( window.matchMedia( '(pointer: coarse)' ).matches ) {
			console.log( 'touch' );
		}
	}*/


	_setBodyClass() {
		if (this.IS_TOUCH)
			this.$html[0].classList.add('touch');
		else
			this.$html[0].classList.add('notouch');
	}


}

